import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Box, Button, DialogActions, DialogContent, Dialog, DialogTitle, Typography } from "@mui/material";
import { route } from "preact-router";
import { ValidateCode } from "../Common/helpers";
export default function NoActionBeforeUseCompleteDialog(props) {
	const handleClose = () => {
		props.onClose();
	};

	return (
		<Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
			<DialogTitle id="add-user-dialog">
				<Typography variant="h5">Action prématurée</Typography>
			</DialogTitle>
			<DialogContent dividers>
				<Typography variant="body1">
					Vous souhaitez effectuer une action mais vous devez d'abord
					<strong> compléter vos informations de profil</strong>
				</Typography>
			</DialogContent>
			<DialogActions>
				<Box display="flex" justifyContent="space-between" alignItems="center" style="width: 100%">
					<Box>
						<Button onClick={handleClose} style="margin: 10px;">
							Fermer
						</Button>
					</Box>
					<Box>
						<Button
							variant="contained"
							onClick={() => {
								window.location.replace("/user");
							}}
						>
							Aller à mon profil
						</Button>
					</Box>
				</Box>
			</DialogActions>
		</Dialog>
	);
}
